<!-- 

超宽屏定制页中心的地图

 -->
<template>
  <div>
    <div id="map-zone"></div>
    <!-- <div
      style="
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        color: #9cd9fc;
        text-align: center;
        line-height: 40px;
      "
    >
      产业概况 | 辐射带动 | 数字莓园 | 数字莓市
    </div> -->
    <div style="height: 0; overflow: hidden">
    </div>
  </div>
</template>
<script>
import { mixins } from './index-mixin'
export default {
  mixins: [mixins],
  data() {
    return {}
  },
}
</script>
<style>
#map-zone {
  background-color: antiquewhite;
  height: 890px;
  border-radius: 20px;
  border: solid 1px #292929;
}
#map-zone .town-name,
#map-zone .town-volumn {
  color: #c3dfff;
  margin: 0;
  padding: 0;
}
#map-zone .town-name {
  font-size: 14px;
  font-weight: bold;
}
#map-zone .town-volumn {
  font-size: 11px;
}

#map-zone .enterprise-name,
#map-zone .enterprise-volumn {
  color: #fff3df;
  margin: 0;
  padding: 0;
}
#map-zone .enterprise-name {
  font-size: 14px;
  font-weight: bold;
}
#map-zone .enterprise-volumn {
  font-size: 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/screen38496/map-zone/index.vue